module.exports = __webpack_public_path__ + "img/76_8.19883aca.png";